/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AmendRequest,
  Clause,
  ClauseRequest,
  CodeRequest,
  ContractCreateRequest,
  ContractDetail,
  ContractReasonRequest,
  ContractTemplate,
  ContractTemplateRequest,
  ContractsClausesListParams,
  ContractsItemsListParams,
  ContractsTemplatesListParams,
  GeneratedDocument,
  PaginatedClauseList,
  PaginatedContractList,
  PaginatedContractTemplateList,
  PatchedClauseRequest,
  PatchedContractDetailRequest,
  PatchedContractTemplateRequest,
  SignatureChannel,
  SignedScanRequest,
  StepRequest
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type contractsClausesListResponse200 = {
  data: PaginatedClauseList
  status: 200
}
    
export type contractsClausesListResponseSuccess = (contractsClausesListResponse200) & {
  headers: Headers;
};
;

export type contractsClausesListResponse = (contractsClausesListResponseSuccess)

export const getContractsClausesListUrl = (params?: ContractsClausesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/contracts/clauses/?${stringifiedParams}` : `/api/v1/contracts/clauses/`
}

export const contractsClausesList = async (params?: ContractsClausesListParams, options?: RequestInit): Promise<contractsClausesListResponse> => {
  
  return apiFetch<contractsClausesListResponse>(getContractsClausesListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getContractsClausesListQueryKey = (params?: ContractsClausesListParams,) => {
    return [
    `/api/v1/contracts/clauses/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getContractsClausesListQueryOptions = <TData = Awaited<ReturnType<typeof contractsClausesList>>, TError = unknown>(params?: ContractsClausesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsClausesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsClausesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsClausesList>>> = ({ signal }) => contractsClausesList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractsClausesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractsClausesListQueryResult = NonNullable<Awaited<ReturnType<typeof contractsClausesList>>>
export type ContractsClausesListQueryError = unknown


export function useContractsClausesList<TData = Awaited<ReturnType<typeof contractsClausesList>>, TError = unknown>(
 params: undefined |  ContractsClausesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsClausesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsClausesList>>,
          TError,
          Awaited<ReturnType<typeof contractsClausesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsClausesList<TData = Awaited<ReturnType<typeof contractsClausesList>>, TError = unknown>(
 params?: ContractsClausesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsClausesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsClausesList>>,
          TError,
          Awaited<ReturnType<typeof contractsClausesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsClausesList<TData = Awaited<ReturnType<typeof contractsClausesList>>, TError = unknown>(
 params?: ContractsClausesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsClausesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useContractsClausesList<TData = Awaited<ReturnType<typeof contractsClausesList>>, TError = unknown>(
 params?: ContractsClausesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsClausesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractsClausesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type contractsClausesCreateResponse201 = {
  data: Clause
  status: 201
}
    
export type contractsClausesCreateResponseSuccess = (contractsClausesCreateResponse201) & {
  headers: Headers;
};
;

export type contractsClausesCreateResponse = (contractsClausesCreateResponseSuccess)

export const getContractsClausesCreateUrl = () => {


  

  return `/api/v1/contracts/clauses/`
}

export const contractsClausesCreate = async (clauseRequest: ClauseRequest, options?: RequestInit): Promise<contractsClausesCreateResponse> => {
  
  return apiFetch<contractsClausesCreateResponse>(getContractsClausesCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      clauseRequest,)
  }
);}




export const getContractsClausesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsClausesCreate>>, TError,{data: ClauseRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof contractsClausesCreate>>, TError,{data: ClauseRequest}, TContext> => {

const mutationKey = ['contractsClausesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contractsClausesCreate>>, {data: ClauseRequest}> = (props) => {
          const {data} = props ?? {};

          return  contractsClausesCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContractsClausesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof contractsClausesCreate>>>
    export type ContractsClausesCreateMutationBody = ClauseRequest
    export type ContractsClausesCreateMutationError = unknown

    export const useContractsClausesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsClausesCreate>>, TError,{data: ClauseRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contractsClausesCreate>>,
        TError,
        {data: ClauseRequest},
        TContext
      > => {

      const mutationOptions = getContractsClausesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type contractsClausesRetrieveResponse200 = {
  data: Clause
  status: 200
}
    
export type contractsClausesRetrieveResponseSuccess = (contractsClausesRetrieveResponse200) & {
  headers: Headers;
};
;

export type contractsClausesRetrieveResponse = (contractsClausesRetrieveResponseSuccess)

export const getContractsClausesRetrieveUrl = (id: string,) => {


  

  return `/api/v1/contracts/clauses/${id}/`
}

export const contractsClausesRetrieve = async (id: string, options?: RequestInit): Promise<contractsClausesRetrieveResponse> => {
  
  return apiFetch<contractsClausesRetrieveResponse>(getContractsClausesRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getContractsClausesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/contracts/clauses/${id}/`
    ] as const;
    }

    
export const getContractsClausesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof contractsClausesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsClausesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsClausesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsClausesRetrieve>>> = ({ signal }) => contractsClausesRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractsClausesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractsClausesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof contractsClausesRetrieve>>>
export type ContractsClausesRetrieveQueryError = unknown


export function useContractsClausesRetrieve<TData = Awaited<ReturnType<typeof contractsClausesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsClausesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsClausesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof contractsClausesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsClausesRetrieve<TData = Awaited<ReturnType<typeof contractsClausesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsClausesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsClausesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof contractsClausesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsClausesRetrieve<TData = Awaited<ReturnType<typeof contractsClausesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsClausesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useContractsClausesRetrieve<TData = Awaited<ReturnType<typeof contractsClausesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsClausesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractsClausesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type contractsClausesPartialUpdateResponse200 = {
  data: Clause
  status: 200
}
    
export type contractsClausesPartialUpdateResponseSuccess = (contractsClausesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type contractsClausesPartialUpdateResponse = (contractsClausesPartialUpdateResponseSuccess)

export const getContractsClausesPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/contracts/clauses/${id}/`
}

export const contractsClausesPartialUpdate = async (id: string,
    patchedClauseRequest: PatchedClauseRequest, options?: RequestInit): Promise<contractsClausesPartialUpdateResponse> => {
  
  return apiFetch<contractsClausesPartialUpdateResponse>(getContractsClausesPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedClauseRequest,)
  }
);}




export const getContractsClausesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsClausesPartialUpdate>>, TError,{id: string;data: PatchedClauseRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof contractsClausesPartialUpdate>>, TError,{id: string;data: PatchedClauseRequest}, TContext> => {

const mutationKey = ['contractsClausesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contractsClausesPartialUpdate>>, {id: string;data: PatchedClauseRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  contractsClausesPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContractsClausesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof contractsClausesPartialUpdate>>>
    export type ContractsClausesPartialUpdateMutationBody = PatchedClauseRequest
    export type ContractsClausesPartialUpdateMutationError = unknown

    export const useContractsClausesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsClausesPartialUpdate>>, TError,{id: string;data: PatchedClauseRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contractsClausesPartialUpdate>>,
        TError,
        {id: string;data: PatchedClauseRequest},
        TContext
      > => {

      const mutationOptions = getContractsClausesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type contractsItemsListResponse200 = {
  data: PaginatedContractList
  status: 200
}
    
export type contractsItemsListResponseSuccess = (contractsItemsListResponse200) & {
  headers: Headers;
};
;

export type contractsItemsListResponse = (contractsItemsListResponseSuccess)

export const getContractsItemsListUrl = (params?: ContractsItemsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/contracts/items/?${stringifiedParams}` : `/api/v1/contracts/items/`
}

export const contractsItemsList = async (params?: ContractsItemsListParams, options?: RequestInit): Promise<contractsItemsListResponse> => {
  
  return apiFetch<contractsItemsListResponse>(getContractsItemsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getContractsItemsListQueryKey = (params?: ContractsItemsListParams,) => {
    return [
    `/api/v1/contracts/items/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getContractsItemsListQueryOptions = <TData = Awaited<ReturnType<typeof contractsItemsList>>, TError = unknown>(params?: ContractsItemsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsItemsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsItemsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsItemsList>>> = ({ signal }) => contractsItemsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractsItemsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractsItemsListQueryResult = NonNullable<Awaited<ReturnType<typeof contractsItemsList>>>
export type ContractsItemsListQueryError = unknown


export function useContractsItemsList<TData = Awaited<ReturnType<typeof contractsItemsList>>, TError = unknown>(
 params: undefined |  ContractsItemsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsItemsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsItemsList>>,
          TError,
          Awaited<ReturnType<typeof contractsItemsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsItemsList<TData = Awaited<ReturnType<typeof contractsItemsList>>, TError = unknown>(
 params?: ContractsItemsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsItemsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsItemsList>>,
          TError,
          Awaited<ReturnType<typeof contractsItemsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsItemsList<TData = Awaited<ReturnType<typeof contractsItemsList>>, TError = unknown>(
 params?: ContractsItemsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsItemsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useContractsItemsList<TData = Awaited<ReturnType<typeof contractsItemsList>>, TError = unknown>(
 params?: ContractsItemsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsItemsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractsItemsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type contractsItemsCreateResponse201 = {
  data: ContractDetail
  status: 201
}
    
export type contractsItemsCreateResponseSuccess = (contractsItemsCreateResponse201) & {
  headers: Headers;
};
;

export type contractsItemsCreateResponse = (contractsItemsCreateResponseSuccess)

export const getContractsItemsCreateUrl = () => {


  

  return `/api/v1/contracts/items/`
}

export const contractsItemsCreate = async (contractCreateRequest: ContractCreateRequest, options?: RequestInit): Promise<contractsItemsCreateResponse> => {
  
  return apiFetch<contractsItemsCreateResponse>(getContractsItemsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      contractCreateRequest,)
  }
);}




export const getContractsItemsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsItemsCreate>>, TError,{data: ContractCreateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof contractsItemsCreate>>, TError,{data: ContractCreateRequest}, TContext> => {

const mutationKey = ['contractsItemsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contractsItemsCreate>>, {data: ContractCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  contractsItemsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContractsItemsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof contractsItemsCreate>>>
    export type ContractsItemsCreateMutationBody = ContractCreateRequest
    export type ContractsItemsCreateMutationError = unknown

    export const useContractsItemsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsItemsCreate>>, TError,{data: ContractCreateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contractsItemsCreate>>,
        TError,
        {data: ContractCreateRequest},
        TContext
      > => {

      const mutationOptions = getContractsItemsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type contractsItemsRetrieveResponse200 = {
  data: ContractDetail
  status: 200
}
    
export type contractsItemsRetrieveResponseSuccess = (contractsItemsRetrieveResponse200) & {
  headers: Headers;
};
;

export type contractsItemsRetrieveResponse = (contractsItemsRetrieveResponseSuccess)

export const getContractsItemsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/contracts/items/${id}/`
}

export const contractsItemsRetrieve = async (id: string, options?: RequestInit): Promise<contractsItemsRetrieveResponse> => {
  
  return apiFetch<contractsItemsRetrieveResponse>(getContractsItemsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getContractsItemsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/contracts/items/${id}/`
    ] as const;
    }

    
export const getContractsItemsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof contractsItemsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsItemsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsItemsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsItemsRetrieve>>> = ({ signal }) => contractsItemsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractsItemsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractsItemsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof contractsItemsRetrieve>>>
export type ContractsItemsRetrieveQueryError = unknown


export function useContractsItemsRetrieve<TData = Awaited<ReturnType<typeof contractsItemsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsItemsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsItemsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof contractsItemsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsItemsRetrieve<TData = Awaited<ReturnType<typeof contractsItemsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsItemsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsItemsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof contractsItemsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsItemsRetrieve<TData = Awaited<ReturnType<typeof contractsItemsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsItemsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useContractsItemsRetrieve<TData = Awaited<ReturnType<typeof contractsItemsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsItemsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractsItemsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type contractsItemsPartialUpdateResponse200 = {
  data: ContractDetail
  status: 200
}
    
export type contractsItemsPartialUpdateResponseSuccess = (contractsItemsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type contractsItemsPartialUpdateResponse = (contractsItemsPartialUpdateResponseSuccess)

export const getContractsItemsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/contracts/items/${id}/`
}

export const contractsItemsPartialUpdate = async (id: string,
    patchedContractDetailRequest: PatchedContractDetailRequest, options?: RequestInit): Promise<contractsItemsPartialUpdateResponse> => {
  
  return apiFetch<contractsItemsPartialUpdateResponse>(getContractsItemsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedContractDetailRequest,)
  }
);}




export const getContractsItemsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsItemsPartialUpdate>>, TError,{id: string;data: PatchedContractDetailRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof contractsItemsPartialUpdate>>, TError,{id: string;data: PatchedContractDetailRequest}, TContext> => {

const mutationKey = ['contractsItemsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contractsItemsPartialUpdate>>, {id: string;data: PatchedContractDetailRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  contractsItemsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContractsItemsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof contractsItemsPartialUpdate>>>
    export type ContractsItemsPartialUpdateMutationBody = PatchedContractDetailRequest
    export type ContractsItemsPartialUpdateMutationError = unknown

    export const useContractsItemsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsItemsPartialUpdate>>, TError,{id: string;data: PatchedContractDetailRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contractsItemsPartialUpdate>>,
        TError,
        {id: string;data: PatchedContractDetailRequest},
        TContext
      > => {

      const mutationOptions = getContractsItemsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type contractsItemsAmendCreateResponse201 = {
  data: ContractDetail
  status: 201
}
    
export type contractsItemsAmendCreateResponseSuccess = (contractsItemsAmendCreateResponse201) & {
  headers: Headers;
};
;

export type contractsItemsAmendCreateResponse = (contractsItemsAmendCreateResponseSuccess)

export const getContractsItemsAmendCreateUrl = (id: string,) => {


  

  return `/api/v1/contracts/items/${id}/amend/`
}

export const contractsItemsAmendCreate = async (id: string,
    amendRequest: AmendRequest, options?: RequestInit): Promise<contractsItemsAmendCreateResponse> => {
  
  return apiFetch<contractsItemsAmendCreateResponse>(getContractsItemsAmendCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      amendRequest,)
  }
);}




export const getContractsItemsAmendCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsItemsAmendCreate>>, TError,{id: string;data: AmendRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof contractsItemsAmendCreate>>, TError,{id: string;data: AmendRequest}, TContext> => {

const mutationKey = ['contractsItemsAmendCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contractsItemsAmendCreate>>, {id: string;data: AmendRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  contractsItemsAmendCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContractsItemsAmendCreateMutationResult = NonNullable<Awaited<ReturnType<typeof contractsItemsAmendCreate>>>
    export type ContractsItemsAmendCreateMutationBody = AmendRequest
    export type ContractsItemsAmendCreateMutationError = unknown

    export const useContractsItemsAmendCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsItemsAmendCreate>>, TError,{id: string;data: AmendRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contractsItemsAmendCreate>>,
        TError,
        {id: string;data: AmendRequest},
        TContext
      > => {

      const mutationOptions = getContractsItemsAmendCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type contractsItemsCancelCreateResponse200 = {
  data: ContractDetail
  status: 200
}
    
export type contractsItemsCancelCreateResponseSuccess = (contractsItemsCancelCreateResponse200) & {
  headers: Headers;
};
;

export type contractsItemsCancelCreateResponse = (contractsItemsCancelCreateResponseSuccess)

export const getContractsItemsCancelCreateUrl = (id: string,) => {


  

  return `/api/v1/contracts/items/${id}/cancel/`
}

export const contractsItemsCancelCreate = async (id: string,
    contractReasonRequest: ContractReasonRequest, options?: RequestInit): Promise<contractsItemsCancelCreateResponse> => {
  
  return apiFetch<contractsItemsCancelCreateResponse>(getContractsItemsCancelCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      contractReasonRequest,)
  }
);}




export const getContractsItemsCancelCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsItemsCancelCreate>>, TError,{id: string;data: ContractReasonRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof contractsItemsCancelCreate>>, TError,{id: string;data: ContractReasonRequest}, TContext> => {

const mutationKey = ['contractsItemsCancelCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contractsItemsCancelCreate>>, {id: string;data: ContractReasonRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  contractsItemsCancelCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContractsItemsCancelCreateMutationResult = NonNullable<Awaited<ReturnType<typeof contractsItemsCancelCreate>>>
    export type ContractsItemsCancelCreateMutationBody = ContractReasonRequest
    export type ContractsItemsCancelCreateMutationError = unknown

    export const useContractsItemsCancelCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsItemsCancelCreate>>, TError,{id: string;data: ContractReasonRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contractsItemsCancelCreate>>,
        TError,
        {id: string;data: ContractReasonRequest},
        TContext
      > => {

      const mutationOptions = getContractsItemsCancelCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type contractsItemsGenerateCreateResponse200 = {
  data: ContractDetail
  status: 200
}
    
export type contractsItemsGenerateCreateResponseSuccess = (contractsItemsGenerateCreateResponse200) & {
  headers: Headers;
};
;

export type contractsItemsGenerateCreateResponse = (contractsItemsGenerateCreateResponseSuccess)

export const getContractsItemsGenerateCreateUrl = (id: string,) => {


  

  return `/api/v1/contracts/items/${id}/generate/`
}

export const contractsItemsGenerateCreate = async (id: string, options?: RequestInit): Promise<contractsItemsGenerateCreateResponse> => {
  
  return apiFetch<contractsItemsGenerateCreateResponse>(getContractsItemsGenerateCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getContractsItemsGenerateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsItemsGenerateCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof contractsItemsGenerateCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['contractsItemsGenerateCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contractsItemsGenerateCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  contractsItemsGenerateCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContractsItemsGenerateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof contractsItemsGenerateCreate>>>
    
    export type ContractsItemsGenerateCreateMutationError = unknown

    export const useContractsItemsGenerateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsItemsGenerateCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contractsItemsGenerateCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getContractsItemsGenerateCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type contractsItemsPreviewCreateResponse201 = {
  data: GeneratedDocument
  status: 201
}
    
export type contractsItemsPreviewCreateResponseSuccess = (contractsItemsPreviewCreateResponse201) & {
  headers: Headers;
};
;

export type contractsItemsPreviewCreateResponse = (contractsItemsPreviewCreateResponseSuccess)

export const getContractsItemsPreviewCreateUrl = (id: string,) => {


  

  return `/api/v1/contracts/items/${id}/preview/`
}

export const contractsItemsPreviewCreate = async (id: string, options?: RequestInit): Promise<contractsItemsPreviewCreateResponse> => {
  
  return apiFetch<contractsItemsPreviewCreateResponse>(getContractsItemsPreviewCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getContractsItemsPreviewCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsItemsPreviewCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof contractsItemsPreviewCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['contractsItemsPreviewCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contractsItemsPreviewCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  contractsItemsPreviewCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContractsItemsPreviewCreateMutationResult = NonNullable<Awaited<ReturnType<typeof contractsItemsPreviewCreate>>>
    
    export type ContractsItemsPreviewCreateMutationError = unknown

    export const useContractsItemsPreviewCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsItemsPreviewCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contractsItemsPreviewCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getContractsItemsPreviewCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Follow the latest published package and template (draft only).
 */
export type contractsItemsRefreshCreateResponse200 = {
  data: ContractDetail
  status: 200
}
    
export type contractsItemsRefreshCreateResponseSuccess = (contractsItemsRefreshCreateResponse200) & {
  headers: Headers;
};
;

export type contractsItemsRefreshCreateResponse = (contractsItemsRefreshCreateResponseSuccess)

export const getContractsItemsRefreshCreateUrl = (id: string,) => {


  

  return `/api/v1/contracts/items/${id}/refresh/`
}

export const contractsItemsRefreshCreate = async (id: string, options?: RequestInit): Promise<contractsItemsRefreshCreateResponse> => {
  
  return apiFetch<contractsItemsRefreshCreateResponse>(getContractsItemsRefreshCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getContractsItemsRefreshCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsItemsRefreshCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof contractsItemsRefreshCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['contractsItemsRefreshCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contractsItemsRefreshCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  contractsItemsRefreshCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContractsItemsRefreshCreateMutationResult = NonNullable<Awaited<ReturnType<typeof contractsItemsRefreshCreate>>>
    
    export type ContractsItemsRefreshCreateMutationError = unknown

    export const useContractsItemsRefreshCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsItemsRefreshCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contractsItemsRefreshCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getContractsItemsRefreshCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Signing at the office: the code goes to the client's phone, the client reads it out.
 */
export type contractsItemsRequestCodeCreateResponse200 = {
  data: SignatureChannel
  status: 200
}
    
export type contractsItemsRequestCodeCreateResponseSuccess = (contractsItemsRequestCodeCreateResponse200) & {
  headers: Headers;
};
;

export type contractsItemsRequestCodeCreateResponse = (contractsItemsRequestCodeCreateResponseSuccess)

export const getContractsItemsRequestCodeCreateUrl = (id: string,) => {


  

  return `/api/v1/contracts/items/${id}/request-code/`
}

export const contractsItemsRequestCodeCreate = async (id: string, options?: RequestInit): Promise<contractsItemsRequestCodeCreateResponse> => {
  
  return apiFetch<contractsItemsRequestCodeCreateResponse>(getContractsItemsRequestCodeCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getContractsItemsRequestCodeCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsItemsRequestCodeCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof contractsItemsRequestCodeCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['contractsItemsRequestCodeCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contractsItemsRequestCodeCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  contractsItemsRequestCodeCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContractsItemsRequestCodeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof contractsItemsRequestCodeCreate>>>
    
    export type ContractsItemsRequestCodeCreateMutationError = unknown

    export const useContractsItemsRequestCodeCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsItemsRequestCodeCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contractsItemsRequestCodeCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getContractsItemsRequestCodeCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type contractsItemsSendCreateResponse200 = {
  data: ContractDetail
  status: 200
}
    
export type contractsItemsSendCreateResponseSuccess = (contractsItemsSendCreateResponse200) & {
  headers: Headers;
};
;

export type contractsItemsSendCreateResponse = (contractsItemsSendCreateResponseSuccess)

export const getContractsItemsSendCreateUrl = (id: string,) => {


  

  return `/api/v1/contracts/items/${id}/send/`
}

export const contractsItemsSendCreate = async (id: string, options?: RequestInit): Promise<contractsItemsSendCreateResponse> => {
  
  return apiFetch<contractsItemsSendCreateResponse>(getContractsItemsSendCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getContractsItemsSendCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsItemsSendCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof contractsItemsSendCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['contractsItemsSendCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contractsItemsSendCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  contractsItemsSendCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContractsItemsSendCreateMutationResult = NonNullable<Awaited<ReturnType<typeof contractsItemsSendCreate>>>
    
    export type ContractsItemsSendCreateMutationError = unknown

    export const useContractsItemsSendCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsItemsSendCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contractsItemsSendCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getContractsItemsSendCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type contractsItemsSignCodeCreateResponse200 = {
  data: ContractDetail
  status: 200
}
    
export type contractsItemsSignCodeCreateResponseSuccess = (contractsItemsSignCodeCreateResponse200) & {
  headers: Headers;
};
;

export type contractsItemsSignCodeCreateResponse = (contractsItemsSignCodeCreateResponseSuccess)

export const getContractsItemsSignCodeCreateUrl = (id: string,) => {


  

  return `/api/v1/contracts/items/${id}/sign-code/`
}

export const contractsItemsSignCodeCreate = async (id: string,
    codeRequest: CodeRequest, options?: RequestInit): Promise<contractsItemsSignCodeCreateResponse> => {
  
  return apiFetch<contractsItemsSignCodeCreateResponse>(getContractsItemsSignCodeCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      codeRequest,)
  }
);}




export const getContractsItemsSignCodeCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsItemsSignCodeCreate>>, TError,{id: string;data: CodeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof contractsItemsSignCodeCreate>>, TError,{id: string;data: CodeRequest}, TContext> => {

const mutationKey = ['contractsItemsSignCodeCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contractsItemsSignCodeCreate>>, {id: string;data: CodeRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  contractsItemsSignCodeCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContractsItemsSignCodeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof contractsItemsSignCodeCreate>>>
    export type ContractsItemsSignCodeCreateMutationBody = CodeRequest
    export type ContractsItemsSignCodeCreateMutationError = unknown

    export const useContractsItemsSignCodeCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsItemsSignCodeCreate>>, TError,{id: string;data: CodeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contractsItemsSignCodeCreate>>,
        TError,
        {id: string;data: CodeRequest},
        TContext
      > => {

      const mutationOptions = getContractsItemsSignCodeCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type contractsItemsSignPaperCreateResponse200 = {
  data: ContractDetail
  status: 200
}
    
export type contractsItemsSignPaperCreateResponseSuccess = (contractsItemsSignPaperCreateResponse200) & {
  headers: Headers;
};
;

export type contractsItemsSignPaperCreateResponse = (contractsItemsSignPaperCreateResponseSuccess)

export const getContractsItemsSignPaperCreateUrl = (id: string,) => {


  

  return `/api/v1/contracts/items/${id}/sign-paper/`
}

export const contractsItemsSignPaperCreate = async (id: string,
    signedScanRequest: SignedScanRequest, options?: RequestInit): Promise<contractsItemsSignPaperCreateResponse> => {
    const formData = new FormData();
formData.append(`scan`, signedScanRequest.scan)

  return apiFetch<contractsItemsSignPaperCreateResponse>(getContractsItemsSignPaperCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getContractsItemsSignPaperCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsItemsSignPaperCreate>>, TError,{id: string;data: SignedScanRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof contractsItemsSignPaperCreate>>, TError,{id: string;data: SignedScanRequest}, TContext> => {

const mutationKey = ['contractsItemsSignPaperCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contractsItemsSignPaperCreate>>, {id: string;data: SignedScanRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  contractsItemsSignPaperCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContractsItemsSignPaperCreateMutationResult = NonNullable<Awaited<ReturnType<typeof contractsItemsSignPaperCreate>>>
    export type ContractsItemsSignPaperCreateMutationBody = SignedScanRequest
    export type ContractsItemsSignPaperCreateMutationError = unknown

    export const useContractsItemsSignPaperCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsItemsSignPaperCreate>>, TError,{id: string;data: SignedScanRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contractsItemsSignPaperCreate>>,
        TError,
        {id: string;data: SignedScanRequest},
        TContext
      > => {

      const mutationOptions = getContractsItemsSignPaperCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The file moved on (e.g. invitation received): the instalments due get invoiced (P2-06)
 */
export type contractsItemsStepCreateResponse200 = {
  data: ContractDetail
  status: 200
}
    
export type contractsItemsStepCreateResponseSuccess = (contractsItemsStepCreateResponse200) & {
  headers: Headers;
};
;

export type contractsItemsStepCreateResponse = (contractsItemsStepCreateResponseSuccess)

export const getContractsItemsStepCreateUrl = (id: string,) => {


  

  return `/api/v1/contracts/items/${id}/step/`
}

export const contractsItemsStepCreate = async (id: string,
    stepRequest: StepRequest, options?: RequestInit): Promise<contractsItemsStepCreateResponse> => {
  
  return apiFetch<contractsItemsStepCreateResponse>(getContractsItemsStepCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stepRequest,)
  }
);}




export const getContractsItemsStepCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsItemsStepCreate>>, TError,{id: string;data: StepRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof contractsItemsStepCreate>>, TError,{id: string;data: StepRequest}, TContext> => {

const mutationKey = ['contractsItemsStepCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contractsItemsStepCreate>>, {id: string;data: StepRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  contractsItemsStepCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContractsItemsStepCreateMutationResult = NonNullable<Awaited<ReturnType<typeof contractsItemsStepCreate>>>
    export type ContractsItemsStepCreateMutationBody = StepRequest
    export type ContractsItemsStepCreateMutationError = unknown

    export const useContractsItemsStepCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsItemsStepCreate>>, TError,{id: string;data: StepRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contractsItemsStepCreate>>,
        TError,
        {id: string;data: StepRequest},
        TContext
      > => {

      const mutationOptions = getContractsItemsStepCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type contractsTemplatesListResponse200 = {
  data: PaginatedContractTemplateList
  status: 200
}
    
export type contractsTemplatesListResponseSuccess = (contractsTemplatesListResponse200) & {
  headers: Headers;
};
;

export type contractsTemplatesListResponse = (contractsTemplatesListResponseSuccess)

export const getContractsTemplatesListUrl = (params?: ContractsTemplatesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/contracts/templates/?${stringifiedParams}` : `/api/v1/contracts/templates/`
}

export const contractsTemplatesList = async (params?: ContractsTemplatesListParams, options?: RequestInit): Promise<contractsTemplatesListResponse> => {
  
  return apiFetch<contractsTemplatesListResponse>(getContractsTemplatesListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getContractsTemplatesListQueryKey = (params?: ContractsTemplatesListParams,) => {
    return [
    `/api/v1/contracts/templates/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getContractsTemplatesListQueryOptions = <TData = Awaited<ReturnType<typeof contractsTemplatesList>>, TError = unknown>(params?: ContractsTemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsTemplatesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsTemplatesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsTemplatesList>>> = ({ signal }) => contractsTemplatesList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractsTemplatesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractsTemplatesListQueryResult = NonNullable<Awaited<ReturnType<typeof contractsTemplatesList>>>
export type ContractsTemplatesListQueryError = unknown


export function useContractsTemplatesList<TData = Awaited<ReturnType<typeof contractsTemplatesList>>, TError = unknown>(
 params: undefined |  ContractsTemplatesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsTemplatesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsTemplatesList>>,
          TError,
          Awaited<ReturnType<typeof contractsTemplatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsTemplatesList<TData = Awaited<ReturnType<typeof contractsTemplatesList>>, TError = unknown>(
 params?: ContractsTemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsTemplatesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsTemplatesList>>,
          TError,
          Awaited<ReturnType<typeof contractsTemplatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsTemplatesList<TData = Awaited<ReturnType<typeof contractsTemplatesList>>, TError = unknown>(
 params?: ContractsTemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsTemplatesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useContractsTemplatesList<TData = Awaited<ReturnType<typeof contractsTemplatesList>>, TError = unknown>(
 params?: ContractsTemplatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsTemplatesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractsTemplatesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type contractsTemplatesCreateResponse201 = {
  data: ContractTemplate
  status: 201
}
    
export type contractsTemplatesCreateResponseSuccess = (contractsTemplatesCreateResponse201) & {
  headers: Headers;
};
;

export type contractsTemplatesCreateResponse = (contractsTemplatesCreateResponseSuccess)

export const getContractsTemplatesCreateUrl = () => {


  

  return `/api/v1/contracts/templates/`
}

export const contractsTemplatesCreate = async (contractTemplateRequest: ContractTemplateRequest, options?: RequestInit): Promise<contractsTemplatesCreateResponse> => {
  
  return apiFetch<contractsTemplatesCreateResponse>(getContractsTemplatesCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      contractTemplateRequest,)
  }
);}




export const getContractsTemplatesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsTemplatesCreate>>, TError,{data: ContractTemplateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof contractsTemplatesCreate>>, TError,{data: ContractTemplateRequest}, TContext> => {

const mutationKey = ['contractsTemplatesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contractsTemplatesCreate>>, {data: ContractTemplateRequest}> = (props) => {
          const {data} = props ?? {};

          return  contractsTemplatesCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContractsTemplatesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof contractsTemplatesCreate>>>
    export type ContractsTemplatesCreateMutationBody = ContractTemplateRequest
    export type ContractsTemplatesCreateMutationError = unknown

    export const useContractsTemplatesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsTemplatesCreate>>, TError,{data: ContractTemplateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contractsTemplatesCreate>>,
        TError,
        {data: ContractTemplateRequest},
        TContext
      > => {

      const mutationOptions = getContractsTemplatesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type contractsTemplatesRetrieveResponse200 = {
  data: ContractTemplate
  status: 200
}
    
export type contractsTemplatesRetrieveResponseSuccess = (contractsTemplatesRetrieveResponse200) & {
  headers: Headers;
};
;

export type contractsTemplatesRetrieveResponse = (contractsTemplatesRetrieveResponseSuccess)

export const getContractsTemplatesRetrieveUrl = (id: string,) => {


  

  return `/api/v1/contracts/templates/${id}/`
}

export const contractsTemplatesRetrieve = async (id: string, options?: RequestInit): Promise<contractsTemplatesRetrieveResponse> => {
  
  return apiFetch<contractsTemplatesRetrieveResponse>(getContractsTemplatesRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getContractsTemplatesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/contracts/templates/${id}/`
    ] as const;
    }

    
export const getContractsTemplatesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof contractsTemplatesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsTemplatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsTemplatesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsTemplatesRetrieve>>> = ({ signal }) => contractsTemplatesRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractsTemplatesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContractsTemplatesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof contractsTemplatesRetrieve>>>
export type ContractsTemplatesRetrieveQueryError = unknown


export function useContractsTemplatesRetrieve<TData = Awaited<ReturnType<typeof contractsTemplatesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsTemplatesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsTemplatesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof contractsTemplatesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsTemplatesRetrieve<TData = Awaited<ReturnType<typeof contractsTemplatesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsTemplatesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsTemplatesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof contractsTemplatesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContractsTemplatesRetrieve<TData = Awaited<ReturnType<typeof contractsTemplatesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsTemplatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useContractsTemplatesRetrieve<TData = Awaited<ReturnType<typeof contractsTemplatesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsTemplatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContractsTemplatesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type contractsTemplatesPartialUpdateResponse200 = {
  data: ContractTemplate
  status: 200
}
    
export type contractsTemplatesPartialUpdateResponseSuccess = (contractsTemplatesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type contractsTemplatesPartialUpdateResponse = (contractsTemplatesPartialUpdateResponseSuccess)

export const getContractsTemplatesPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/contracts/templates/${id}/`
}

export const contractsTemplatesPartialUpdate = async (id: string,
    patchedContractTemplateRequest: PatchedContractTemplateRequest, options?: RequestInit): Promise<contractsTemplatesPartialUpdateResponse> => {
  
  return apiFetch<contractsTemplatesPartialUpdateResponse>(getContractsTemplatesPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedContractTemplateRequest,)
  }
);}




export const getContractsTemplatesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsTemplatesPartialUpdate>>, TError,{id: string;data: PatchedContractTemplateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof contractsTemplatesPartialUpdate>>, TError,{id: string;data: PatchedContractTemplateRequest}, TContext> => {

const mutationKey = ['contractsTemplatesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contractsTemplatesPartialUpdate>>, {id: string;data: PatchedContractTemplateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  contractsTemplatesPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContractsTemplatesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof contractsTemplatesPartialUpdate>>>
    export type ContractsTemplatesPartialUpdateMutationBody = PatchedContractTemplateRequest
    export type ContractsTemplatesPartialUpdateMutationError = unknown

    export const useContractsTemplatesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsTemplatesPartialUpdate>>, TError,{id: string;data: PatchedContractTemplateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contractsTemplatesPartialUpdate>>,
        TError,
        {id: string;data: PatchedContractTemplateRequest},
        TContext
      > => {

      const mutationOptions = getContractsTemplatesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    